export const apiName: string = 'modelos';
export const modelosRoute: string = 'modelos';
export const modelosStorage: string = 'modelos';
export const modelosModuleName: any = {plural: 'Modelos', single: 'Modelo'};

export const modelosQueryComCategoria: any = {"Modelo":{"modelo":{"regexp":"/REPLACEHERE/i"},"ativo":true},"Categoria": {"id":"REPLACECATEGORIAID"}};

export const modelosQueryComCategoriaMarca: any = {"Modelo":{"modelo":{"regexp":"/REPLACEHERE/i"},"ativo":true,"marcaId":"REPLACEMARCAID"},"Categoria": {"id":"REPLACECATEGORIAID"}};



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/modelos/shared/data.service.ts
 **/